import getIn from 'transmute/getIn';
import { VERIFY_FBM_INSTALL, REQUEST_STATUS, PAGE_NAME, PAGE_LINK, PAGE_CONFIG } from '../constants/keyPaths';
export const getVerifyFbmInstall = getIn(VERIFY_FBM_INSTALL);
export const getConfig = getIn(PAGE_CONFIG);
export const getRequestStatus = getIn(REQUEST_STATUS);
export const getPageName = getIn(PAGE_NAME);
export const getPageLink = getIn(PAGE_LINK);